import React from "react";
import Page, { PageProps } from "../Page";
import { IPositionTypesPresenter } from "../../../presenter/position/PositionTypesPresenter";
import DataGrid from "../../components/app/grid/DataGrid";
import { Form } from "antd";
import CreatePositionTypeForm, {
  CreatePositionTypeFormProps
} from "./CreatePositionTypeForm";
import UpdatePositionTypeForm, {
  UpdatePositionTypeFormProps
} from "./UpdatePositionTypeForm";
import Loader from "../../components/Loader";
export interface Props extends PageProps {}
export interface State extends IPositionTypesPresenter {}

export default class PositionTypesPage extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe(result => {
      return this.setState(prevState => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    let { translate, positionTypes = [] } = this.state;
    const CreateForm = Form.create<CreatePositionTypeFormProps>({})(
      CreatePositionTypeForm
    );

    const UpdateForm = Form.create<UpdatePositionTypeFormProps>({})(
      UpdatePositionTypeForm
    );

    const columns = [
      {
        title: translate("position_types_page.name"),
        dataIndex: "name",
        key: "name"
      },
      {
        title: translate("position_types_page.data_source"),
        dataIndex: "dataSource",
        key: "dataSource"
      }
    ];

    const dataGrid = (
      <DataGrid
        title={translate("grids.position-types")}
        translate={translate}
        columns={columns}
        dataSource={positionTypes}
        allowCreate={true}
        allowDelete={false}
        allowUpdate={true}
        createForm={CreateForm}
        onCreate={this.state.createPositionType}
        createModalTitle={translate("position_types_page.insert_modal_title")}
        updateForm={UpdateForm}
        updateModalTitle={translate("position_types_page.update_modal_title")}
        onUpdate={this.state.updatePositionType}
        addButtonText={translate("position_types_page.add_button_text")}
        editableRecordProp={"editable"}
      />
    );

    return (
      <Page {...this.props}>
        <Loader
          children={dataGrid}
          translate={translate}
          loading={this.state.loaders.positionTypesLoader}
        />
      </Page>
    );
  }
}
